import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getThreePLPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.THREE_PL,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  const shipmentPattern = /\/shipments\/shipmentprofile\/\d+\/(\d+)/;
  const shipmentMatch = url.match(shipmentPattern);
  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
}
